import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import GameCard from '@/components/entities/games/GameCard';
import GameSkeleton from '@/components/entities/games/GameCard/components/GameSkeleton';
import { buttonVariants } from '@/components/ui/Button/button';
import { TOP_GAMES_CATEGORY_ID } from '@/consts/topGamesCategory';
import { AppRoutes } from '@/i18n/constants';
import { Link } from '@/i18n/routing';
import { gameQueryOptions } from '@/queries/games/games.queries';
import { cn } from '@/utils/cn';

export default function PopularGames() {
  const t = useTranslations('lobby.filters');
  const { data: popularGames, isLoading } = useQuery(gameQueryOptions.list({
    params: {
      page: 1,
      limit: 9,
      filters: { categoryId: TOP_GAMES_CATEGORY_ID },
    },
  }),
  );

  if (isLoading) {
    return (
      <div className="lg:hidden">
        <p className="text-light font-medium text-lg mb-2.5 lg:mb-3.25 lg:leading-5.5 leading-8">{t('top-games')}</p>
        <div className="grid grid-cols-3 md:grid-cols-4 gap-1.75 md:gap-5 pb-3">
          {Array.from({ length: 9 }).map((_, index) => (
            <GameSkeleton key={index} className="p-0" />
          ))}
        </div>
      </div>
    );
  }

  if (!popularGames?.items?.length) {
    return null;
  }

  return (
    <div className="lg:hidden">
      <p className="text-light font-medium text-lg mb-2.5 lg:mb-3.25 lg:leading-5.5 leading-8">{t('top-games')}</p>
      <div className="grid grid-cols-3 md:grid-cols-4 gap-1.75  md:gap-5 mb-6">
        {popularGames.items.map(game => (
          <GameCard
            likeButtonPosition="compact"
            likeButtonIconSize="compactLg"
            key={game.id}
            id={game.id}
            name={game.name}
            className="p-0"
            cover={game.cover}
            path={AppRoutes.gamesId(game.id)}
          />
        ))}
      </div>
      <div className="pb-2">
        {/* TODO: Think about Button asChild or buttonVariants */}
        <Link className={cn(buttonVariants({ variant: 'secondary', size: 'md' }), 'text-[0.875rem] font-medium leading-5 w-full max-lg:h-13 py-3')} href={AppRoutes.categoryIdPaged(TOP_GAMES_CATEGORY_ID)}>{t('show-all')}</Link>
      </div>
    </div>
  );
}
